import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 42 42"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "40",
      height: "40",
      x: "1",
      y: "1",
      fill: "#EAF3FE",
      stroke: "#4893F4",
      "stroke-dasharray": "8.62 1.72",
      "stroke-width": "1.5",
      rx: "20"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#4893F4",
      d: "M28 18c-.803-3.696-4.292-5-7-5 0 0 .008 0 0 0-2.7 0-6.197 1.304-7 5-.895 4.128 1.3 7.666 3 10 1.217 1.672 2.96 4 4 4s2.852-2.4 4-4c1.147-1.6 3.895-5.872 3-10m-7 4c-1.331 0-2-.608-2-2s.669-3 2-3 3 1.608 3 3-1.67 2-3 2"
    }, null, -1)
  ]))]))
}
export default { render: render }